import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      className="footer-section"
      // gradient using brand colors; remove bg image to avoid clash
      style={{
        background:
          "linear-gradient(180deg, #0a2740 0%, #003b66 55%, #0a2740 100%)",
      }}
    >
      <div className="container">
        {/* Top brand row */}
        <div className="footer-brand-row">
          <div className="brand-left">
            <img
              src="/images/logo.png"
              alt="Amruta Travels"
              className="footer-logo"
            />
            <p className="brand-tagline">
              Reliable buses & tempo travellers for city & outstation travel.
            </p>
          </div>

          <div className="brand-right">
            <a className="brand-pill" href="tel:+918010014995">
              <i className="fa-solid fa-phone"></i> +91 8010014995
            </a>
            <a className="brand-pill" href="mailto:booking@amrutatravelspvtltd.com">
              <i className="fa-regular fa-envelope"></i> booking@amrutatravelspvtltd.com
            </a>
          </div>
        </div>

        <div className="footer-widget-wrapper-new">
          <div className="row">
            {/* Col 1 */}
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay=".2s">
              <div className="single-widget-items">
                <div className="widget-head">
                  <h4>Our Services</h4>
                  <span className="widget-underline" />
                </div>
               <Link className="footer-link" to="/24-seater-bus-for-rent-in-pune">
  <i className="fa fa-bus"></i> 24 Seater Bus for Rent in Pune
</Link>
<Link className="footer-link" to="/16-seater-urbania-for-rent-in-pune">
  <i className="fa fa-bus"></i> 16 Seater Urbania for Rent in Pune
</Link>
<Link className="footer-link" to="/14-seater-urbania-hire-in-pune">
  <i className="fa fa-bus"></i> 14 Seater Urbania Hire in Pune
</Link>
<Link className="footer-link" to="/17-seater-urbania-hire-in-pune">
  <i className="fa fa-bus"></i> 17 Seater Urbania Hire in Pune
</Link>
<Link className="footer-link" to="/mini-bus-on-rent-in-pimpri-chinchwad">
  <i className="fa fa-bus"></i> Mini Bus On Rent in Pimpri Chinchwad
</Link>
<Link className="footer-link" to="/mini-bus-on-rent-in-pune">
  <i className="fa fa-bus"></i> Mini Bus On Rent in Pune
</Link>
<Link className="footer-link" to="/force-urbania-17-seater-on-rent-in-pune">
  <i className="fa fa-bus"></i> Force Urbania 17 Seater On Rent in Pune
</Link>
<Link className="footer-link" to="/35-seater-bus-on-rent-in-pune">
  <i className="fa fa-bus"></i> 35 Seater Bus On Rent in Pune
</Link>
<Link className="footer-link" to="/45-seater-bus-on-rent-in-pune">
  <i className="fa fa-bus"></i> 45 Seater Bus On Rent in Pune
</Link>
<Link className="footer-link" to="/53-seater-bus-on-rent-in-pune">
  <i className="fa fa-bus"></i> 53 Seater Bus On Rent in Pune
</Link>
<Link className="footer-link" to="/50-seater-bus-on-rent-in-pune">
  <i className="fa fa-bus"></i> 50 Seater Bus On Rent in Pune
</Link>
<Link className="footer-link" to="/bus-on-rent-in-pune">
  <i className="fa fa-bus"></i> Bus On Rent in Pune
</Link>


              </div>
            </div>

            {/* Col 2 */}
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay=".3s">
              <div className="single-widget-items">
                <div className="widget-head">
                  <h4>Our Services</h4>
                  <span className="widget-underline" />
                </div>
            <Link className="footer-link" to="/bus-hire-in-pune">
  <i className="fa fa-bus"></i> Bus Hire in Pune
</Link>
<Link className="footer-link" to="/bus-on-rent-in-pimpri-chinchwad">
  <i className="fa fa-bus"></i> Bus On Rent in Pimpri Chinchwad
</Link>
<Link className="footer-link" to="/bus-rental-for-corporate-events-in-pune">
  <i className="fa fa-bus"></i> Bus Rental for Corporate Events in Pune
</Link>
<Link className="footer-link" to="/wedding-bus-booking-online-pune">
  <i className="fa fa-bus"></i> Wedding Bus Booking Online Pune
</Link>
<Link className="footer-link" to="/bus-hire-for-school-trips-in-pune">
  <i className="fa fa-bus"></i> Bus Hire for School Trips in Pune
</Link>
<Link className="footer-link" to="/bus-hire-for-party-events-in-pune">
  <i className="fa fa-bus"></i> Bus Hire for Party Events in Pune
</Link>
<Link className="footer-link" to="/full-bus-booking-for-marriage-pune">
  <i className="fa fa-bus"></i> Full Bus Booking for Marriage Pune
</Link>
<Link className="footer-link" to="/ac-luxury-bus-on-rent-in-pune">
  <i className="fa fa-bus"></i> AC Luxury Bus On Rent in Pune
</Link>
<Link className="footer-link" to="/urbania-on-rent-in-pune">
  <i className="fa fa-bus"></i> Urbania On Rent in Pune
</Link>

              </div>
            </div>

            {/* Col 3 */}
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay=".4s">
              <div className="single-widget-items">
                <div className="widget-head">
                  <h4>Our Services</h4>
                  <span className="widget-underline" />
                </div>
             <Link className="footer-link" to="/luxury-force-urbania-on-rent-in-pune">
  <i className="fa fa-bus"></i> Luxury Force Urbania On Rent in Pune
</Link>
<Link className="footer-link" to="/urbania-on-rent-in-pune-for-corporate">
  <i className="fa fa-bus"></i> Urbania On Rent in Pune for Corporate
</Link>
<Link className="footer-link" to="/pune-to-goa-urbania-on-rent">
  <i className="fa fa-bus"></i> Pune to Goa Urbania On Rent
</Link>
<Link className="footer-link" to="/pune-to-mumbai-urbania-on-rent">
  <i className="fa fa-bus"></i> Pune to Mumbai Urbania On Rent
</Link>
<Link className="footer-link" to="/force-urbania-luxury-mini-bus-on-rent">
  <i className="fa fa-bus"></i> Force Urbania Luxury Mini Bus On Rent
</Link>
<Link className="footer-link" to="/pune-to-mahabaleshwar-urbania-on-rent">
  <i className="fa fa-bus"></i> Pune to Mahabaleshwar Urbania On Rent
</Link>
<Link className="footer-link" to="/17-seater-force-urbania-on-rent-in-pune">
  <i className="fa fa-bus"></i> 17 Seater Force Urbania on Rent in Pune
</Link>
<Link className="footer-link" to="/urbania-hire-for-outstation-in-pune">
  <i className="fa fa-bus"></i> Urbania Hire for Outstation in Pune
</Link>
<Link className="footer-link" to="/urbania-on-rent-in-pimpri-chinchwad">
  <i className="fa fa-bus"></i> Urbania On Rent in Pimpri Chinchwad
</Link>
              </div>
            </div>

            {/* Contact */}
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 wow fadeInUp" data-wow-delay=".5s">
              <div className="single-widget-items">
                <div className="widget-head">
                  <h4>Contact Us</h4>
                  <span className="widget-underline" />
                </div>

                <div className="contact-items">
                  <div className="icon circle">
                    <i className="fa-solid fa-phone"></i>
                  </div>
                  <div className="content">
                    <a href="tel:+918010014995" className="contact-link">+91 8010014995</a>
                  </div>
                </div>

                <div className="contact-items">
                  <div className="icon circle">
                    <i className="fa-regular fa-envelope"></i>
                  </div>
                  <div className="content">
                    <a href="mailto:booking@amrutatravelspvtltd.com" className="contact-link">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </div>
                </div>

                <div className="contact-items">
                  <div className="icon circle">
                    <i className="fas fa-location-dot"></i>
                  </div>
                  <div className="content">
                 
                    <span className="contact-text">   <p>Amruta Travels Pvt Ltd</p>Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="copyright-text">
            © {new Date().getFullYear()} <strong>Amruta Travels</strong>. Developed by{" "}
            <a href="https://www.dexterintelligence.com/" target="_blank" rel="noopener noreferrer">
              Dexter Intelligence
            </a>{" "}
            | Hosted by{" "}
            <a href="https://www.urvahosting.com/" target="_blank" rel="noopener noreferrer">
              Urva Hosting
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
